import { css, SerializedStyles } from '@emotion/core'

import { FontSize } from '../../../enums/fontSize'
import { FontWeight } from '../../../enums/fontWeight'
import { LineHeight } from '../../../enums/lineHeight'
import { Spacing } from '../../../enums/spacing'
import { TagSize } from '../types'

export type TagIconSize = 'xs' | 'sm' | 'md'

export const tagIconSize: Record<TagSize, TagIconSize> = {
  xs: 'xs',
  sm: 'xs',
  md: 'sm',
  lg: 'md',
}

export const getSizeStyle = (size: TagSize): SerializedStyles =>
  ({
    xs: css`
      padding: 0 ${Spacing.S4};
      gap: ${Spacing.S6};
      font-size: ${FontSize.TextBodySM};
      font-weight: ${FontWeight.Medium};
      line-height: ${LineHeight.TextBodySM};
    `,
    sm: css`
      padding: ${Spacing.S2} ${Spacing.S6};
      gap: ${Spacing.S6};
      font-size: ${FontSize.TextBodySM};
      font-weight: ${FontWeight.Medium};
      line-height: ${LineHeight.TextBodySM};
    `,
    md: css`
      padding: ${Spacing.S2} ${Spacing.S6};
      gap: ${Spacing.S6};
      font-size: ${FontSize.TextBodyMD};
      font-weight: ${FontWeight.Medium};
      line-height: ${LineHeight.TextBodyMD};
    `,
    lg: css`
      padding: ${Spacing.S4} ${Spacing.S6};
      gap: ${Spacing.S8};
      font-size: ${FontSize.TextBodyLG};
      font-weight: ${FontWeight.Medium};
      line-height: ${LineHeight.TextBodyLG};
    `,
  })[size]
